import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Tooltip } from "primereact/tooltip";

const HomeCarusel = ({ t, caruselData, caruselIndex, setCaruselIndex }: any) => {
    return (
        <div className="flex justify-content-between">
            <div className="flex flex-column align-items-start gap-2">
                <img src={caruselData[caruselIndex]?.img} alt="" />
                <div className="flex flex-column justify-content-between">
                    <div className="flex gap-2 align-items-center">
                        <p className="m-0 text-md" style={{ color: "#727A99" }}>{t(caruselData[caruselIndex]?.title)}</p>
                        {caruselIndex === 0 &&
                            <>
                                <Tooltip target=".info-icon">
                                    <div>
                                        {t('activePatientsTooltip')}
                                    </div>
                                </Tooltip>
                                <img src="/infoIcon.svg" style={{ width: "1.5rem", height: "1.5rem" }} className="info-icon" />
                            </>}
                    </div>

                    <p className="m-0 text-4xl font-bold" style={{ color: "#2D3967", lineHeight: "1" }}>{caruselData[caruselIndex]?.value}</p>
                </div>
            </div>
            <div className="flex justify-content-between align-items-start gap-2">
                <Button icon="pi pi-chevron-left"
                    disabled={caruselIndex === 0}
                    onClick={() => setCaruselIndex(caruselIndex - 1)}
                    style={{ backgroundColor: "#EAEBF0", border: "none", borderRadius: "10px", width: "2rem", height: "2rem", color: "#2D3967" }} />
                <Button icon="pi pi-chevron-right" disabled={caruselIndex === caruselData.length - 1} onClick={() => setCaruselIndex(caruselIndex + 1)} style={{ backgroundColor: "#EAEBF0", border: "none", borderRadius: "10px", width: "2rem", height: "2rem", color: "#2D3967" }} />
            </div>
        </div>


    )
}

export default HomeCarusel;